export default {
  RequiredField: ' is required.',
  InvalidEmail: 'Valid email required.'
};
